export default __webpack_public_path__ + "static/media/background-2.a91b6016.png";